import { Group, Image, Stack, Text } from '@mantine/core';
import { getSessionTypeDisplay } from '../utils/sessionTypeDisplay';

type SessionCategoryCellProps = {
  type?: string | null;
  scenario?: string | null;
  source?: string | null;
};

export const SessionCategoryCell = ({
  type,
  scenario,
  source,
}: SessionCategoryCellProps) => {
  const display = getSessionTypeDisplay(type, scenario, source);

  return (
    <Group gap='sm' wrap='nowrap' align='center'>
      <Image src={display.iconUrl} w={24} h={24} fit='contain' alt='' />
      <Stack gap={0}>
        <Text size='sm' fw={500} lh={1.3}>
          {display.productLabel}
        </Text>
        {display.mappedLabel || display.scenarioLabel ? (
          <Text size='xs' c='dimmed' lh={1.3}>
            {[display.mappedLabel, display.scenarioLabel]
              .filter(Boolean)
              .join(' · ')}
          </Text>
        ) : null}
      </Stack>
    </Group>
  );
};
